import React, {useEffect, useRef, useState} from 'react'
import styles from './skillActivity.module.scss'

import API from 'Class/API'
import Auth from 'Class/Auth'

import Error from 'Components/Feedback/Error'
import ScrollView from 'Components/UI/ScrollView'
import Spinner from 'Components/Feedback/Spinner'
import Subscriber from './subscriber'

export const SkillActivitySubscriptions = ({community, current, getTranslation = () => {}, id}) => {

    const [error, setError] = useState(false)
    const [loading, setLoading] = useState(true)
    const [subscriptions, setSubscriptions] = useState([])
    const isMounted = useRef(true)

    useEffect(() => () => { isMounted.current = false }, [])
    useEffect(() =>
    {
        const fetchSubscriptions = async () =>
        {
            if (!isMounted.current)
            {
                return;
            }
            
            setError(false)
            setLoading(true)
            const {error, message, subscriptions} = await API.RequestAsync('skillActivities/subscriptions',
            {
                activity: id,
                community
            })

            if (!isMounted.current)
            {
                return;
            }

            setLoading(false)
            setError(error ? message || getTranslation('error') : false)
            setSubscriptions(subscriptions || [])
        }
        fetchSubscriptions()
    }, [community, id]);

    let content = ''

    if (loading)
    {
        content = <Spinner className={styles.spinner} overlay={true}/>
    }
    else if (error)
    {
        content = <Error className={styles.error} label={error} />
    }
    else if (subscriptions.length)
    {
        content = (
            <ScrollView className={styles.list}>{subscriptions.map(subscription => (
                <Subscriber
                    {...subscription}
                    getTranslation={getTranslation}
                    key={subscription.id}
                    {...(parseInt(subscription.user, 10) === Auth.UserId && current ? {status: current[0], updated: current[1]} : {})}
                />
            ))}</ScrollView>
        )
    } else
    {
        content = <div className={styles.empty}>{getTranslation('nosubscriptions')}</div>
    }

    return (
        <div className={styles.subscriptions}>
            {content}
        </div>
    )
}

export default SkillActivitySubscriptions